import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "@/content/defaults";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const imgSrc = (v) =>
  v && v.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${v}` : v;

export const deepMerge = (base, over) => {
  if (Array.isArray(base)) {
    if (!Array.isArray(over)) return base;
    return over.map((o, i) => (i < base.length ? deepMerge(base[i], o) : o));
  }
  if (base && typeof base === "object") {
    const out = {};
    for (const k of Object.keys(base)) {
      out[k] = over && typeof over === "object" && !Array.isArray(over) && over[k] !== undefined
        ? deepMerge(base[k], over[k])
        : base[k];
    }
    if (over && typeof over === "object" && !Array.isArray(over)) {
      for (const k of Object.keys(over)) if (!(k in out)) out[k] = over[k];
    }
    return out;
  }
  return over !== undefined ? over : base;
};

const ContentContext = createContext({
  content: DEFAULT_CONTENT,
  overrides: {},
  refresh: () => {},
});

export const ContentProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setOverrides(data?.data && typeof data.data === "object" ? data.data : {});
    } catch {
      setOverrides({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const content = deepMerge(DEFAULT_CONTENT, overrides);

  return (
    <ContentContext.Provider value={{ content, overrides, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
